import React, { Component } from "react";
import { connect } from "react-redux";
import { updateMotorLayout, validateMotorLayout } from "../actions/";

class MotorLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validMotorLayout: true,
      motorLayout: [
        {
          value: "Motor ports left, case drain ports top and bottom",
          orderCode: "0",
          img: "mot1"
        },
        {
          value: "Motor ports on top, case drain ports left and right",
          orderCode: "1",
          img: "mot2"
        },
        {
          value: "Motor ports right, case drain ports top and bottom",
          orderCode: "2",
          img: "mot3"
        },
        {
          value: "Motor ports on bottom, case drain ports left and right",
          orderCode: "3",
          img: "mot4"
        }
      ],
      hover: {
        mot1: false,
        mot2: false,
        mot3: false,
        mot4: false
      }
    };
    this.handleOnchange = this.handleOnchange.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  handleOnchange = selected => {
    this.props.onLayoutSelect(JSON.parse(selected.target.value));
    this.props.validateMotorLayout(true);
  };

  onMouseOver(hoverIn) {
    var motor = hoverIn.target.className;
    if (motor === "mot1 closed" || motor === "input1 closed") {
      this.setState({
        hover: {
          ...this.state.hover,
          mot1: true
        }
      });
    } else if (motor === "mot2 closed" || motor === "input2 closed") {
      this.setState({
        hover: {
          ...this.state.hover,
          mot2: true
        }
      });
    } else if (motor === "mot3 closed" || motor === "input3 closed") {
      this.setState({
        hover: {
          ...this.state.hover,
          mot3: true
        }
      });
    } else if (motor === "mot4 closed" || motor === "input4 closed") {
      this.setState({
        hover: {
          ...this.state.hover,
          mot4: true
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.validMotorLayout !== this.props.validMotorLayout) {
      if (!this.props.validMotorLayout) {
        this.setState({
          validMotorLayout: false
        });
      } else {
        this.setState({
          validMotorLayout: true
        });
      }
    }
    // if (this.props.winchType.orderCode !== prevProps.winchType.orderCode) {
    //   this.props.onLayoutSelect("");
    //   var ele = document.getElementsByName("motor_layout");
    //   for (var i = 0; i < ele.length; i++) ele[i].checked = false;
    // }
    if (this.props.previewStatus !== prevProps.previewStatus) {
      this.setState({
        hover: {
          mot1: this.props.motorLayout.orderCode === "0",
          mot2: this.props.motorLayout.orderCode === "1",
          mot3: this.props.motorLayout.orderCode === "2",
          mot4: this.props.motorLayout.orderCode === "3"
        }
      });
    }
  }

  onMouseOut(out) {
    this.setState({
      hover: {
        mot1: this.props.motorLayout.orderCode === "0",
        mot2: this.props.motorLayout.orderCode === "1",
        mot3: this.props.motorLayout.orderCode === "2",
        mot4: this.props.motorLayout.orderCode === "3"
      }
    });
  }

  render() {
    var mLayout = this.state.motorLayout;
    return (
      <div>
        <div className="field-top">Motor layout</div>
        <div className="selection-body">
          <p>
            Motor ports can be located on the right, left, bottom or top
            position of the winch.
          </p>
          {this.state.validMotorLayout === false && (
            <p className="warning">Motor layout is required.</p>
          )}
          <div className="row" onChange={this.handleOnchange}>
            <div className="col-md-6 ">
              <label
                className={"mot1 " + (!this.state.hover.mot1 ? "closed" : "")}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              >
                <input
                  type="radio"
                  value={JSON.stringify(mLayout[0])}
                  name="motor_layout"
                  defaultChecked={
                    this.props.motorLayout.orderCode === mLayout[0].orderCode
                  }
                  onMouseOver={this.onMouseOver}
                  onMouseOut={this.onMouseOut}
                  className={
                    "input1 " + (!this.state.hover.ccru ? "closed" : "")
                  }
                />{" "}
                {mLayout[0].value}
                <div
                  className={
                    "img-container " + (this.state.hover.mot1 ? "active" : "")
                  }
                >
                  <img
                    className="item-img-mot"
                    src={"../images/" + mLayout[0].img + ".png"}
                    alt="mot1"
                  />
                </div>
              </label>
            </div>
            <div className="col-md-6 ">
              <label
                className={"mot2 " + (!this.state.hover.mot2 ? "closed" : "")}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              >
                <input
                  type="radio"
                  value={JSON.stringify(mLayout[1])}
                  name="motor_layout"
                  onMouseOver={this.onMouseOver}
                  onMouseOut={this.onMouseOut}
                  defaultChecked={
                    this.props.motorLayout.orderCode === mLayout[1].orderCode
                  }
                  className={
                    "input2 " + (!this.state.hover.ccru ? "closed" : "")
                  }
                />{" "}
                {mLayout[1].value}
                <div
                  className={
                    "img-container " + (this.state.hover.mot2 ? "active" : "")
                  }
                >
                  <img
                    className="item-img-mot"
                    src={"../images/" + mLayout[1].img + ".png"}
                    alt="mot1"
                  />
                </div>
              </label>
            </div>
            <div className="col-md-6 ">
              <label
                className={"mot3 " + (!this.state.hover.mot3 ? "closed" : "")}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              >
                <input
                  type="radio"
                  value={JSON.stringify(mLayout[2])}
                  name="motor_layout"
                  onMouseOver={this.onMouseOver}
                  onMouseOut={this.onMouseOut}
                  defaultChecked={
                    this.props.motorLayout.orderCode === mLayout[2].orderCode
                  }
                  className={
                    "input3 " + (!this.state.hover.ccru ? "closed" : "")
                  }
                />{" "}
                {mLayout[2].value}
                <div
                  className={
                    "img-container " + (this.state.hover.mot3 ? "active" : "")
                  }
                >
                  <img
                    className="item-img-mot"
                    src={"../images/" + mLayout[2].img + ".png"}
                    alt="mot1"
                  />
                </div>
              </label>
            </div>
            <div className="col-md-6 ">
              <label
                className={"mot4 " + (!this.state.hover.mot4 ? "closed" : "")}
                onMouseOver={this.onMouseOver}
                onMouseOut={this.onMouseOut}
              >
                <input
                  type="radio"
                  value={JSON.stringify(mLayout[3])}
                  name="motor_layout"
                  onMouseOver={this.onMouseOver}
                  onMouseOut={this.onMouseOut}
                  defaultChecked={
                    this.props.motorLayout.orderCode === mLayout[3].orderCode
                  }
                  className={
                    "input4 " + (!this.state.hover.ccru ? "closed" : "")
                  }
                />{" "}
                {mLayout[3].value}
                <div
                  className={
                    "img-container " + (this.state.hover.mot4 ? "active" : "")
                  }
                >
                  <img
                    className="item-img-mot"
                    src={"../images/" + mLayout[3].img + ".png"}
                    alt="mot1"
                  />
                </div>
              </label>
            </div>
          </div>
        </div>
        <br />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mType: state.mType,
    winchType: state.winchType,
    motorLayout: state.motorLayout,
    previewStatus: state.previewStatus,
    validMotorLayout: state.validMotorLayout
  };
};

const mapActionToProps = {
  onLayoutSelect: updateMotorLayout,
  validateMotorLayout: validateMotorLayout
};

export default connect(
  mapStateToProps,
  mapActionToProps
)(MotorLayout);



// WEBPACK FOOTER //
// ./src/components/motorLayout.js